import { createAction, props } from '@ngrx/store';
import { ErrorModel, SessionEvaluationInstrument, Session, ProgressActivityModel } from '@tekman/onmat/models';

export const loadSessions = createAction('[Steps/API] Load Sessions', props<{ itineraryId: string; stepId: string; groupId: string }>());
export const loadSessionsSuccess = createAction(
  '[Steps/API] Load Sessions Success',
  props<{ stepId: string; sessions: Session[]; groupId: string }>()
);
export const loadSessionsFailure = createAction('[Steps/API] Load Sessions Failure', props<{ error: ErrorModel }>());

export const orderedSessionsSuccess = createAction('[Step/Sessions] Ordered Sessions Success');

export const loadEvaluationInstruments = createAction(
  '[Steps/API] Load Evaluation Instruments',
  props<{ stepId: string; groupId: string }>()
);
export const loadEvaluationInstrumentsSuccess = createAction(
  '[Steps/API] Load Evaluation Instruments Success',
  props<{ stepId: string; evaluationInstruments: SessionEvaluationInstrument[]; groupId: string }>()
);
export const loadEvaluationInstrumentsFailure = createAction(
  '[Steps/API] Load Evaluation Instruments Failure',
  props<{ error: ErrorModel }>()
);

export const loadOtherActivities = createAction(
  '[Steps/API] Load Other Activities',
  props<{ itineraryId: string; stepId: string; groupId: string }>()
);
export const loadOtherActivitiesSuccess = createAction(
  '[Steps/API] Load Other Activities Success',
  props<{ stepId: string; otherActivities: SessionEvaluationInstrument[] }>()
);
export const loadOtherActivitiesFailure = createAction('[Steps/API] Load Other Activities Failure', props<{ error: ErrorModel }>());

export const resetSessionsLoaded = createAction('[Step/Sessions] Reset Sessions Loaded');
export const updateSteps = createAction(
  '[Step/Sessions] Update Steps',
  props<{ itineraryId: string; stepId: string; sessions: Session[]; groupId: string }>()
);
export const updateStepsSuccess = createAction('[Step/Sessions] Update Steps Success', props<{ sessions: Session[] }>());
export const updateStepsFailure = createAction('[Step/Sessions] Update Steps Failure');
export const loadStudentExerciseProgressSuccess = createAction(
  '[Step] Load Progress Exercise Student Success',
  props<{ exercisesProgress: ProgressActivityModel }>()
);
export const loadStudentExerciseProgressFailure = createAction(
  '[Step] Load Progress Exercise Student Failure',
  props<{ error: ErrorModel }>()
);
